import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import VueCookies from 'vue-cookies'
import {  
  Collapse, CollapseItem,Cell, CellGroup,
  Toast,Checkbox, CheckboxGroup,Lazyload,PasswordInput,NumberKeyboard,Popup,Overlay,Icon,PullRefresh,
  RadioGroup, Radio,List,Tab, Tabs 


} from 'vant';
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(Toast);
Vue.use(Lazyload);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Popup);
Vue.use(PullRefresh);
Vue.use(VueCookies)
Vue.use(List);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Lazyload, {
  preLoad: 1.3,
  lazyComponent: true,
});
Vue.use(Icon);
Vue.use(Overlay);
//excel
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
import './assets/icon/iconfont.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

require('@/api/mock.js')
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
  beforeCreate() {
    //这个this指的就是vm!
    Vue.prototype.$bus = this
  },
}).$mount('#app')
